const BASE_PATH = '/status/data/historical'

export default {
  getKeyParameter: data => ({
    url: `${BASE_PATH}/site`,
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/StatusData.js